<template>
  <div>
    <!--公共返回的字段-->
    <div class="group-ready-status" v-if="checkData">
      <div class="group-header">
        <!-- <h2>设备组就绪状态</h2> -->
        <div class="summary">
          <div v-if="checkData.groupId" class="summary-item">
            <span class="label">组ID:</span>
            <span class="value">{{ checkData.groupId }}</span>
          </div>
          <div v-if="checkData.uid" class="summary-item">
            <span class="label">UID:</span>
            <span class="value">{{ checkData.uid }}</span>
          </div>
          <div class="summary-item">
            <span class="label">测试时间:</span>
            <span class="value">{{ formatDate(checkData.startDate) }} 至 {{ formatDate(checkData.stopDate) }}</span>
          </div>
          <div class="summary-item">
            <span class="label">统计耗时:</span>
            <span class="value">{{ checkData.usedSeconds }}秒</span>
          </div>
        </div>
      </div>

      <!-- 版本信息 -->
      <div v-if="checkData.versions" class="versions-section">
        <h3>固件版本分布 <i class="el-icon-info" title="列出分组下各版本及对应设备UID，便于确保所有设备都已升级至最新版"></i></h3>
        <div class="version-list">
          <div v-for="(devices, version) in checkData.versions" :key="version" class="version-card">
            <div class="version-header">
              <span class="version-name">{{ version }}</span>
              <span class="device-count">{{ devices.length }} 台设备</span>
            </div>
            <div class="device-list">
              <span v-for="device in devices" :key="device" class="device-id" :title="device">
                {{ device }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- 日期设备状态 -->
      <div class="date-devices-section">
        <h3>每日设备状态</h3>
        <el-tabs v-model="activeDate" type="card">
          <el-tab-pane v-for="(dateData, date) in checkData.dates" :key="date" :label="formatDate(date)" :name="date">
            <div class="device-grid">
              <div v-for="(device, deviceId) in dateData.devices" :key="deviceId" class="device-card" :class="getDeviceStatusClass(device)">
                <div class="device-header">
                  <span class="device-id" :title="deviceId">{{ deviceId }}</span>
                  <span class="status-badge" :class="device.missing.length > 0 ? 'warning' : 'success'" :title="device.missing.length > 0 ? '设备存在数据缺失' : '设备运行正常'">
                    {{ device.missing.length > 0 ? '异常' : '正常' }}
                  </span>
                </div>

                <div class="device-details">
                  <div class="detail-row">
                    <span class="label" title="设备型号">型号:</span>
                    <span class="value">{{ device.model }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="label" title="固件版本号">版本:</span>
                    <span class="value">{{ device.version }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="label" title="数据采集间隔时间">采集间隔:</span>
                    <span class="value">{{ device.sample }}秒</span>
                  </div>
                  <div class="detail-row">
                    <span class="label" title="数据上报间隔时间">上报间隔:</span>
                    <span class="value">{{ device.report }}秒</span>
                  </div>
                  <div class="detail-row">
                    <span class="label" title="实际上报条数 / 理想上报条数">上报条数:</span>
                    <span class="value">{{ device.reportCount }} / {{ device.idealReportCount }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="label" title="设备上线次数">上线次数:</span>
                    <span class="value">{{ device.onlineTimes }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="label" title="设备离线次数">离线次数:</span>
                    <span class="value">{{ device.offlineTimes }}</span>
                  </div>
                </div>
                <!-- 显示字段验证信息 -->
                <div v-if="device.fields && Object.keys(device.fields).length > 0" class="fields-validation">
                  <h4>字段验证规则:</h4>
                  <el-tabs type="border-card" v-model="activeFieldTab[deviceId]" :key="deviceId + '_tabs'">
                    <el-tab-pane v-for="(fieldRules, fieldName) in device.fields" :key="fieldName" :label="getFieldTitle(fieldName) || fieldName" :name="fieldName">
                      <div class="field-rules-container">
                        <template v-if="Object.keys(fieldRules).length > 0">
                          <div v-for="(times, ruleType) in fieldRules" :key="ruleType" class="rule-item">
                            <span class="rule-type">{{ getRuleTypeName(ruleType) }}:</span>
                            <div class="rule-times-container">
                              <div class="rule-times">
                                <span v-for="(time, idx) in times" :key="idx" class="rule-time">{{ time }}</span>
                              </div>
                            </div>
                          </div>
                        </template>

                        <span v-else class="no-data-tip">无数据</span>

                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>

                <div v-if="device.missing.length > 0" class="missing-data">
                  <h4>缺失数据时间:</h4>
                  <div class="missing-list">
                    <div v-for="(missing, idx) in device.missing" :key="idx" class="missing-item" :title="missing">
                      {{ missing }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div v-else class="no-data">
      <span v-if="!monitorState">暂无数据，请在上方查询条件中查询设备组就绪状态</span>
      <div v-else>
        <div><i class="el-icon-loading"></i>正在查询中，请等待。。。</div>
        <div style="font-size: 12px;margin-top: 10px;">(查询的设备多和时间区间过长时，需要更长的时间。长时间无反应请重新查询)</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      groups: {

      },
      devices: {

      },
      activeDate: '',
      fields: {
      },
      checkData: null,  //存储返回值
      activeFieldTab: {},
      monitorState: false,
    }
  },
  computed: {
    dates() {
      return this.checkData != null ? Object.keys(this.checkData.dates) : [];
    },

  },
  watch: {
    checkData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal.dates).length > 0 && !this.activeDate) {
          this.activeDate = Object.keys(newVal.dates)[0];
        }

        // 初始化 activeFieldTab 对象
        if (newVal && newVal.dates) {
          Object.keys(newVal.dates).forEach(date => {
            const devices = newVal.dates[date].devices;
            Object.keys(devices).forEach(deviceId => {
              if (!this.activeFieldTab[deviceId]) {
                const device = devices[deviceId];
                if (device.fields && Object.keys(device.fields).length > 0) {
                  // 设置第一个字段为默认选中的标签页
                  this.activeFieldTab[deviceId] = Object.keys(device.fields)[0];
                }
              }
            });
          });
        }
        // 当接收到查询结果时，重置查询状态
        if (newVal) {
          this.$store.commit('settingStore/SET_MONITORSTATE', false);
        }

      },
      immediate: true
    },
    '$store.state.curTreeData': {
      handler(val) {
        this.cleanData();
      },

    },
    '$store.state.settingStore.monitorState': {
      handler(val) {
        this.monitorState = this.$store.state.settingStore.monitorState
        // console.log('执行清理', val, Object.keys(this.fields).length);

        if (val && this.checkData !== null) {
          this.checkData = null
          this.activeFieldTab = {};
          this.activeDate = '';

        }
      },

    },
  },
  methods: {
    formatDate(dateStr) {
      // 将 YYYYMMDD 格式转换为 YYYY-MM-DD
      if (!dateStr) return '';
      const str = String(dateStr);
      if (str.length !== 8) return str;

      const year = str.substring(0, 4);
      const month = str.substring(4, 6);
      const day = str.substring(6, 8);
      return `${year}-${month}-${day}`;
    },
    // 获取字段标题
    getFieldTitle(fieldName) {
      return this.fields[fieldName] ? this.fields[fieldName].title : fieldName;
    },
    getDeviceStatusClass(device) {
      if (device.missing.length > 0) {
        return 'device-warning';
      }
      return 'device-success';
    },
    // 获取规则类型的中文名称
    getRuleTypeName(ruleType) {
      const ruleTypes = {
        'mustExist': '必须存在',
        'mustNotEmpty': '不能为空',
        'mustBeNumber': '必须为数字',
        'min': '最小值',
        'max': '最大值',
        'maxChangeRate': '最大变化率'
      };

      return ruleTypes[ruleType] || ruleType;
    },
    //清理数据
    cleanData() {
      this.activeDate = '';
      this.fields = {};
      this.checkData = null
      this.activeFieldTab = {};
    }

  },
  ready() {

  },
  mounted() {
    this.ws.addCallback('checkGroupReady', (res) => {
      // console.log('checkGroupReady', res);
      let resData = res
      delete resData.cmd
      this.checkData = resData
    })
    this.ws.addCallback('checkDeviceReady', (res) => {
      // console.log('checkDeviceReady', res);
      let resData = res
      delete resData.cmd
      this.checkData = resData
    })
    //返回可用配置
    this.ws.addCallback('checkProfileAck', (res) => {
      if (res.fields) {
        this.fields = res.fields;
      }

    })
    // this.checkData = this.devices

  },
}
</script>

<style lang="scss" scoped>
.group-ready-status {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100%;
}

.group-header {
  margin-bottom: 20px;
  margin-bottom: 20px;
  position: static; /* 确保header在正常文档流中 */
  top: auto;
  z-index: auto;
}

.header h2 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 24px;
}

.summary {
  display: flex;
  gap: 30px;
  padding: 15px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.summary-item .label {
  font-weight: bold;
  color: #606266;
}

.summary-item .value {
  color: #303133;
}

.versions-section,
.date-devices-section {
  margin-bottom: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.versions-section h3,
.date-devices-section h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #303133;
}

.versions-section h3 i {
  color: #909399;
  margin-left: 5px;
  cursor: help;
}

.version-list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.version-card {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 15px;
  width: 600px;
  background-color: #fafafa;
}

.version-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.version-name {
  font-weight: bold;
  color: #606266;
}

.device-count {
  background-color: #ecf5ff;
  color: #409eff;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}

.device-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.device-id {
  background-color: #f4f4f5;
  color: #909399;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  cursor: help;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.device-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 15px;
  padding-top: 15px;
}

.device-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 15px;
  transition: all 0.3s;
  position: relative;
}

.device-card.device-success {
  border-left: 4px solid #67c23a;
}

.device-card.device-warning {
  border-left: 4px solid #e6a23c;
}

.device-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.device-id {
  font-weight: bold;
  color: #303133;
  cursor: help;
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  color: white;
}

.status-badge.success {
  background-color: #67c23a;
}

.status-badge.warning {
  background-color: #e6a23c;
}

.device-details {
  margin-bottom: 15px;
}

.detail-row {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
}

.detail-row .label {
  width: 100px;
  color: #909399;
  font-weight: normal;
  cursor: help;
}

.detail-row .value {
  flex: 1;
  color: #303133;
}

.missing-data {
  padding-top: 10px;
  border-top: 1px dashed #ebeef5;
}

.missing-data h4 {
  margin: 0 0 10px 0;
  color: #e6a23c;
  font-size: 14px;
}

.missing-list {
  max-height: 100px;
  overflow-y: auto;
}

.missing-item {
  background-color: #fdf6ec;
  color: #e6a23c;
  padding: 2px 6px;
  margin-bottom: 4px;
  border-radius: 4px;
  font-size: 12px;
  word-break: break-all;
  cursor: help;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.no-data {
  text-align: center;
  padding: 40px;
  color: #909399;
  font-size: 16px;
}

/* Element UI Tabs 样式调整 */
::v-deep .el-tabs__item {
  height: 40px;
  line-height: 40px;
}

::v-deep .el-tab-pane {
  padding: 15px 0;
}
// 新增字段验证规则样式
.fields-validation {
  padding-top: 10px;
  border-top: 1px dashed #ebeef5;
  margin-top: 10px;
}

.fields-validation h4 {
  margin: 0 0 10px 0;
  color: #409eff;
  font-size: 14px;
}

.field-rules-container {
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.rule-item {
  margin-bottom: 15px;
  padding: 8px;
  background-color: #fff;
  border-left: 3px solid #409eff;
  border-radius: 2px;
}

.rule-type {
  display: inline-block;
  width: 100px;
  color: #909399;
  font-weight: bold;
  font-size: 13px;
}

.rule-times-container {
  display: block;
  margin-top: 5px;
  padding-left: 10px;
}

.rule-times {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  max-height: 120px;
  overflow-y: auto;
  padding: 5px;
}

.rule-time {
  display: inline-block;
  background-color: #ecf5ff;
  color: #409eff;
  padding: 4px 8px;
  margin: 2px;
  border-radius: 4px;
  font-size: 12px;
  border: 1px solid #b3d8ff;
}
</style>